import type { ReactNode } from "react";
import styles from "./sticky-save-bar.module.css";

export function StickySaveBar({
  status,
  tone = "neutral",
  children,
}: {
  status: ReactNode;
  tone?: "neutral" | "success" | "warning" | "danger";
  children: ReactNode;
}) {
  return (
    <div className={styles.bar} data-tone={tone}>
      <div className={styles.status} role="status">{status}</div>
      <div className={styles.actions}>{children}</div>
    </div>
  );
}
